import { useState } from 'react'
import { RollbackOutlined } from '@ant-design/icons'
import { Popover, Tooltip } from 'antd'

import Link from '~/core/Link'

import ConfirmResetPopoverContent from './ConfirmResetPopoverContent'
import styles from './styles.css'

type ResetSlideIconPropsType = {
    dfmFeedbackId?: string | null
}

const ResetSlideIcon = (props: ResetSlideIconPropsType) => {
    const { dfmFeedbackId } = props

    const [visible, setVisible] = useState(false)

    const togglePopover = () => setVisible(!visible)

    return (
        <Popover
            content={
                <ConfirmResetPopoverContent
                    dfmFeedbackId={dfmFeedbackId}
                    togglePopover={togglePopover}
                />
            }
            onVisibleChange={togglePopover}
            overlayStyle={{ maxWidth: '322px' }}
            placement="topRight"
            trigger="click"
            visible={visible}
        >
            <Tooltip placement="top" title="Reset status">
                <Link
                    data-test-target="reset-slide"
                    name="reset-slide"
                    onClick={(evt: Event) => evt.stopPropagation()}
                    placement="im-dfm-slide"
                >
                    <RollbackOutlined className={styles.resetIcon} />
                </Link>
            </Tooltip>
        </Popover>
    )
}

export default ResetSlideIcon
